export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.1-1258.31",
  commitId: "6c11782d8570fc1b7fd0bb2a29866e3aae944c0f",
  commitTime: "2026-09-01T12:58:31.000Z",
});
